import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// GET ALL
export const fetchBranches = createAsyncThunk(
  "branch/fetchBranches",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_BRANCH, {
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// CREATE
export const createBranch = createAsyncThunk(
  "branch/createBranch",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_BRANCH,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// UPDATE
export const updateBranch = createAsyncThunk(
  "branch/updateBranch",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_BRANCH,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// DELETE
export const deleteBranch = createAsyncThunk(
  "branch/deleteBranch",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.delete(
        `${API_ENDPOINTS.DELETE_BRANCH}?branchId=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// SEARCH
export const searchBranch = createAsyncThunk(
  "branch/searchBranch",
  async (name, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.SEARCH_BRANCH}?branchName=${name}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const BranchSlice = createSlice({
  name: "branch",
  initialState: {
    fetch: { data: [], loading: false, error: null },
    create: { data: null, loading: false, error: null },
    update: { data: null, loading: false, error: null },
    delete: { data: null, loading: false, error: null },
    search: { data: [], loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchBranches.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
      })

      // CREATE
      .addCase(createBranch.pending, (state) => {
        state.create.loading = true;
        state.create.error = null;
      })
      .addCase(createBranch.fulfilled, (state, action) => {
        state.create.loading = false;
        state.create.data = action.payload;
      })
      .addCase(createBranch.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
      })

      // UPDATE
      .addCase(updateBranch.pending, (state) => {
        state.update.loading = true;
        state.update.error = null;
      })
      .addCase(updateBranch.fulfilled, (state, action) => {
        state.update.loading = false;
        state.update.data = action.payload;
      })
      .addCase(updateBranch.rejected, (state, action) => {
        state.update.loading = false;
        state.update.error = action.payload;
      })

      // DELETE
      .addCase(deleteBranch.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.delete.loading = false;
        state.delete.data = action.payload;
      })
      .addCase(deleteBranch.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
      })

      // SEARCH
      .addCase(searchBranch.pending, (state) => {
        state.search.loading = true;
        state.search.error = null;
      })
      .addCase(searchBranch.fulfilled, (state, action) => {
        state.search.loading = false;
        state.search.data = action.payload || [];
      })
      .addCase(searchBranch.rejected, (state, action) => {
        state.search.loading = false;
        state.search.error = action.payload;
      });
  },
});

export default BranchSlice.reducer;
